import { Button, FormGroup, Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React, { Component, MouseEvent } from 'react'
import { connect } from 'react-redux'

import { DispatchProp } from 'modules/store'

import * as fromStore from '../../../app/admin/store'
import { isEmpty, MultiselectOption, MultiselectWrapper } from '../../../app/shared'

import { SyncIndicator } from '../sync-indicator'
import { FieldAdapterProps, MultiselectProps } from '../types'
import { createHelperText, createLabelWithId, createRequiredLabel, getIntent, identity } from '../utils'
import * as fromMultiselect from './multiselect-adapter.actions'
import { getMultiselectData, getMultiselectLoading, selectMultiselectState } from './multiselect-adapter.reducer'
import { MultiselectActionPayload } from './types'

export type StateProps = {
  options: MultiselectOption[]
  isLoading: boolean
}

type OwnProps = MultiselectActionPayload & {
  initialValue?: any
  enableSyncControl?: boolean
  disabled?: boolean
  onSyncChange?(fieldName: string, newValue: boolean): void
  normalize(data: any[]): MultiselectOption[]
}

export type Props = FieldAdapterProps<MultiselectProps> & StateProps & DispatchProp & OwnProps

const mapStateToProps = (state: fromStore.AppState, { storeId, normalize }: OwnProps) => ({
  options: getMultiselectData<MultiselectOption[]>(selectMultiselectState(state), storeId, normalize),
  isLoading: getMultiselectLoading(selectMultiselectState(state), storeId),
})

const enhance = connect(mapStateToProps)
class MultiselectAdapter extends Component<Props> {
  componentWillUnmount() {
    this.props.dispatch(new fromMultiselect.CleanMultiselectDataAction(this.props.storeId))
  }

  render() {
    const {
      fields,
      meta,
      disabled = false,
      required,
      options,
      label,
      inline,
      intent,
      helperText,
      translate = identity,
      enableSyncControl,
      isLoading,
      // tslint:disable-next-line:no-empty
      onSyncChange = (fieldName: string, newValue: boolean) => {},
    } = this.props

    const { id, labelText } = createLabelWithId(fields, label)
    const intentType = getIntent(meta, intent)
    const helperTextMessage = createHelperText(meta, helperText, translate)
    const labelInfo = createRequiredLabel(required, translate)

    const reqLabelMod = (
      <>
        {labelInfo}
        {enableSyncControl && (
          <SyncIndicator
            translate={translate}
            fieldName={fields.name}
            disabled={disabled}
            onSyncChange={onSyncChange}
          />
        )}
      </>
    )

    return (
      <FormGroup
        className={labelInfo ? 'required' : ''}
        helperText={helperTextMessage}
        label={labelText}
        labelFor={id}
        labelInfo={reqLabelMod}
        intent={intentType}
        inline={inline}
        disabled={disabled}
      >
        <MultiselectWrapper
          hasButton={this.isRemoveVisible}
          onAdd={this.handleAdd}
          onRemove={this.handleRemove}
          items={options}
          onInputChange={this.handleTextChange}
          selectedItems={fields.value}
          isLoading={isLoading}
          translate={translate}
          disabled={disabled}
        />
        {this.isRemoveVisible && (
          <Button
            className="multiselect-popover__button bp3-minimal bp3-small"
            icon={<Icon icon={IconNames.CROSS} title={false} />}
            onClick={this.handleReset}
            disabled={disabled}
          />
        )}
      </FormGroup>
    )
  }

  private get isRemoveVisible() {
    return this.props.fields.length > 0
  }

  private handleAdd = (item: MultiselectOption) => {
    this.props.fields.push(item)
  }

  private handleRemove = (index: number) => {
    this.props.fields.remove(index)
  }

  private handleReset = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    event.preventDefault()

    const length = this.props.fields.length
    for (let i = length; i > 0; i--) {
      this.props.fields.remove(i - 1)
    }
  }

  private handleTextChange = (query: string) => {
    const { dispatch, storeId, params, endpointUrl } = this.props

    if (isEmpty(query)) {
      dispatch(new fromMultiselect.CleanMultiselectDataAction(storeId))

      return
    }

    const newParams = {
      Search: query,
      ...params,
    }

    dispatch(
      new fromMultiselect.GetMultiselectDataAction({
        endpointUrl,
        params: newParams,

        storeId,
      })
    )
  }
}

export default enhance(MultiselectAdapter)



// WEBPACK FOOTER //
// ./src/modules/forms/multiselect-adapter/multiselect-adapter.tsx